import React from 'react';
import Header from '../Header/Header';
import PageContainer from '../PageContainer/PageContainer';
import Footer from '../Footer/Footer';
import './MenuItemDetailSkeleton.css';

const Shimmer: React.FC<{ className?: string }> = ({ className = '' }) => (
  <span className={`mid-shimmer ${className}`.trim()} aria-hidden="true" />
);

const MenuItemDetailSkeleton: React.FC = () => (
  <div className="menu-item-detail-page menu-item-detail-page--skeleton" aria-busy="true" aria-label="Loading menu item">
    <Header />
    <PageContainer>
      <div className="menu-item-detail-shell">
        <div className="mid-skel-breadcrumb" aria-hidden="true">
          <Shimmer className="mid-skel-crumb mid-skel-crumb--short" />
          <span className="mid-skel-sep" />
          <Shimmer className="mid-skel-crumb" />
          <span className="mid-skel-sep" />
          <Shimmer className="mid-skel-crumb mid-skel-crumb--long" />
        </div>

        <div className="menu-item-detail-main">
          <div className="menu-item-detail-grid mid-skel-grid">
            <div className="mid-skel-gallery">
              <Shimmer className="mid-skel-gallery-main" />
              <div className="mid-skel-thumbs">
                {Array.from({ length: 4 }).map((_, i) => (
                  <Shimmer key={i} className="mid-skel-thumb" />
                ))}
              </div>
            </div>

            <div className="mid-skel-info">
              <Shimmer className="mid-skel-restaurant-tag" />
              <Shimmer className="mid-skel-title" />
              <Shimmer className="mid-skel-title mid-skel-title--short" />
              <Shimmer className="mid-skel-desc" />
              <Shimmer className="mid-skel-desc mid-skel-desc--short" />

              <Shimmer className="mid-skel-stock" />

              <div className="mid-skel-pills">
                {Array.from({ length: 4 }).map((_, i) => (
                  <Shimmer key={i} className="mid-skel-pill" />
                ))}
              </div>

              <div className="mid-skel-options-card">
                <Shimmer className="mid-skel-options-title" />
                <div className="mid-skel-options-chips">
                  <Shimmer className="mid-skel-chip" />
                  <Shimmer className="mid-skel-chip mid-skel-chip--wide" />
                  <Shimmer className="mid-skel-chip" />
                </div>
              </div>

              <div className="mid-skel-price-row">
                <Shimmer className="mid-skel-mrp" />
                <Shimmer className="mid-skel-price" />
                <Shimmer className="mid-skel-discount" />
              </div>

              <Shimmer className="mid-skel-savings" />

              <div className="mid-skel-actions">
                <div className="mid-skel-qty-block">
                  <Shimmer className="mid-skel-qty-label" />
                  <Shimmer className="mid-skel-qty" />
                </div>
                <Shimmer className="mid-skel-add-btn" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageContainer>
    <Footer variant="restaurant" />
  </div>
);

export default MenuItemDetailSkeleton;
